/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationInstanceCount
 */
export interface NotificationInstanceCount {
    /**
     * 
     * @type {number}
     * @memberof NotificationInstanceCount
     */
    readonly count: number;
}

/**
 * Check if a given object implements the NotificationInstanceCount interface.
 */
export function instanceOfNotificationInstanceCount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function NotificationInstanceCountFromJSON(json: any): NotificationInstanceCount {
    return NotificationInstanceCountFromJSONTyped(json, false);
}

export function NotificationInstanceCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationInstanceCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function NotificationInstanceCountToJSON(value?: NotificationInstanceCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

